import React from 'react';
import { SidebarRail as StyledSidebarRail, RailIconButton } from '../../styled';
import { usePersonalizationState } from '../../store';
import { getMemberLevelColors, getLoyaltyLevelDisplayName } from '../../utils/memberLevelColors';
import { MLogoContainer } from '@marriott/mi-web-ui-kit';

interface SidebarRailProps {
  isOpen: boolean;
  onToggle: () => void;
  onNewChat: () => void;
}

export const SidebarRail: React.FC<SidebarRailProps> = ({ isOpen, onNewChat, onToggle }) => {
  const { usePersonalization: _usePersonalization, mockProfileData } = usePersonalizationState();

  if (isOpen) return null;
  // Get member level colors if personalization is enabled
  const _memberColors = mockProfileData
    ? getMemberLevelColors(mockProfileData.loyaltyCode)
    : { background: '#E5E7EB', text: '#1C1C1C' };

  const tooltipText = mockProfileData
    ? `${mockProfileData.name} - ${getLoyaltyLevelDisplayName(mockProfileData.loyaltyLevel)}`
    : 'Sign In';
  return (
    <StyledSidebarRail open>
      <div className="logo-container">
        <span
          className="icon-double-chevron-right icon-m mt-4 mb-3 cursor-pointer expand-icon"
          // onMouseLeave={() => setShowIcon(false)}
          onClick={() => onToggle()}
        />
        <MLogoContainer
          brand={'mbs'}
          aspectRatio={'3:2'}
          width={49}
          height={63}
          alignment={'Centered'}
          isLink={false}
          color={'background-aware'}
          ariaRole="img"
          onClick={() => onToggle()}
          className="logo"
          // onMouseEnter={() => setShowIcon(true)}
        />
      </div>

      <RailIconButton onClick={onNewChat} className="mt-5 m-tooltip-right" data-content="New chat">
        <span className="icon-chat icon-m" />
      </RailIconButton>
    </StyledSidebarRail>
  );
};
